import { className } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, set } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import styles from "./lesson-title.module.css"

export default class LessonTitleComponent extends Component {
  readonly styles = styles

  // Args
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit
  lesson!: CardStack
  perspective!: string
  collapseLessons!: Function
  onLessonFocus!: Function
  lessonsCollapsed!: Function
  recalcHeights!: Function
  gridIndex!: string
  isNewLesson!: boolean

  @className("take-course-background-color")

  // Properties
  hasFocus = false

  // Services
  @service("ember-store") store!: EmberStore
  @service lessonEditor!: LessonEditor

  oldLessonTitle: string | null = null
  didReceiveAttrs() {
    if (this.lesson && this.recalcHeights && this.lesson.attributes.title !== this.oldLessonTitle) {
      this.oldLessonTitle = this.lesson.attributes.title || null
      this.recalcHeights(this.gridIndex)
    }
  }

  @action
  onTitleEdited(value) {
    this.lessonEditor.editTitle(this.modelsNeededForFirstEdit, this.lesson.id, value, false)
  }

  @action
  onFinishedEditingTitle(value, originalValue) {
    this.lessonEditor.finishEditingTitle(
      this.modelsNeededForFirstEdit,
      this.lesson.id,
      value,
      originalValue
    )
    if (this.recalcHeights) this.recalcHeights(this.gridIndex)
  }

  @action
  onFocusIn() {
    set(this, "hasFocus", true)
    this.onLessonFocus()
  }

  @action
  onFocusOut() {
    set(this, "hasFocus", false)
  }
}
